import { useEffect, useRef } from "react";

const AssignedLockbox = (props) => {
  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    props.visible && (
      <div
        ref={popupref}
        className="w-full bg-white border border-gray-300 rounded-md gk-scr p-[10px] absolute z-50 top-[50px] left-[0px] self-start"
        style={props.style}
      >
        <div className="w-full overflow-x-auto max-h-[120px]">
          {(props.status || []).map((item, index) => {
            const isDisabled = item.disabled;

            return (
              <div
                key={index}
                onClick={() => {
                  if (isDisabled) return; // 🚫 block click
                  props.onClickcorrect(item);
                }}
                className={`flex flex-row items-center w-full py-[5px] text-sm rounded-xl transition
        ${
          isDisabled
            ? "text-gray-400 cursor-not-allowed bg-gray-100"
            : "cursor-pointer hover:bg-themeColor hover:text-white hover:px-[10px]"
        }`}
              >
                <p className="font-medium PoppinsRegular text-sm">
                  {item.displayLabel || item}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};

export default AssignedLockbox;
